<template>
  <div>
    <!-- แถบแรก -->
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          รายการธนาคาร
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <!-- Table Function -->
          <b-row class="mx-auto mb-2">
            <b-col cols="12 text-right">
              <b-button :to="'/bank/bank_form_create'" variant="btn-primary" class="btn bg-gradient-primary waves-effect waves-light"><span><feather-icon icon="PlusIcon" /></span>เพิ่มธนาคาร </b-button>
            </b-col>
          </b-row>
          <!-- End Table Function -->
          <!-- Table Header -->
          <b-row>
            <b-col md="3" sm="2" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">แสดง</label>
                <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" v-on:change="onPageSelect" style="width: 60px"/>
                <label class="d-inline-block text-sm-right ml-50">รายการ</label>
              </b-form-group>
            </b-col>
            <b-col md="5" sm="6" class="my-1" />
            <b-col md="4" sm="4" class="my-1">
              <b-form-group label="ค้นหา :" label-cols-sm="6" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0" >
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filter" v-on:change="onPageSelect" type="search" />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"> ล้าง </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- End Table Header -->
          <!-- Table Body -->
          <b-row>
            <b-col cols="12">
              <b-table hover responsive :fields="fields_bank" :items="items_bank" :filter="filter_bank" :filter-included-fields="filterOn_bank" show-empty>
                <template #empty="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #emptyfiltered="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #cell(start_time_can_not_deposit)="data">
                  <span v-if="data.value != null && data.item.end_time_can_not_deposit">{{ data.value }} - {{ data.item.end_time_can_not_deposit }}</span>
                </template>
                <template #cell(max_amount_withdraw_auto)="data">
                  <span>{{ func.toNum(data.value) }}</span>
                </template>
                <template #cell(status)="data">
                  <b-form-select v-model="data.value" :options="option_toggle" v-on:change="update_status($event, data.item.id)" />
                </template>
                <template #cell(status_withdraw)="data">
                  <b-form-select v-model="data.value" :options="option_toggle" v-on:change="update_status_withdraw($event, data.item.id)" />
                </template>
                <template #cell(manage)="data">
                  <div class="btn-group">
                    <b-dropdown variant="link" toggle-class="bg-gradient-success waves-effect waves-light">
                      <template #button-content>
                        <span><feather-icon icon="EditIcon" class="font-medium-1 mr-1" /></span>จัดการ
                      </template>
                      <b-dropdown-item :to="'/bank/bank_form_update/' + data.item.id"><span><feather-icon icon="EditIcon" class="text-warning mr-1" /></span>แก้ไข</b-dropdown-item>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item @click="remove" :data-id="data.item.id" :data-name="data.item.bank_number"><span><feather-icon icon="TrashIcon" class="text-danger mr-1" /></span>ลบ</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- End Table Body -->
          <!-- Table Footer -->
          <b-row>
            <b-col sm="12" md="5">
              <div role="status" aria-live="polite">แสดง 1 ถึง {{ items_bank.length }} จาก {{func.toNum(items_bank.length)}} รายการ</div>
            </b-col>
            <b-col sm="12" md="7">
              <b-pagination
                v-on:change="onPageChange"
                v-model="currentPage"
                :total-rows="items_bank.length"
                :per-page="perPage"
                align="end"
                size="sm"
                class="my-0"
                :first-number="true"
                :last-number="true"
              >
                <template #prev-text>‹ ย้อนกลับ</template>
                <template #next-text>ถัดไป ›</template>
              </b-pagination>
            </b-col>
          </b-row>
          <!-- End Table Footer -->
        </b-card-body>
      </div>
    </b-card>
    <!-- สิ้นสุดแถบแรก -->
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCol, BRow, BTable, BInputGroup, BInputGroupPrepend, BFormInput, BButton, BFormGroup, BInputGroupAppend, BFormSelect,
  BPagination, BDropdown, BDropdownItem, BDropdownDivider,
  BCollapse, VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import func from '@core/comp-functions/misc/func'

export default {
  components: {
    BCard, BCardHeader, BCardBody,
    BCol, BRow, BTable, BCollapse,
    BInputGroup, BInputGroupPrepend, BFormInput, BFormGroup, BInputGroupAppend,
    BButton,
    BFormSelect,
    BPagination,
    BDropdown, BDropdownItem, BDropdownDivider,
    vSelect,
    flatPickr,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      func: func,
      BASE_URL: process.env.BASE_URL,
      date_start_report: '',
      date_end_report: '',
      draw: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 50,
      currentPage: 5,
      recordsTotal: 0,
      option_toggle: [
        {text: 'ปิด', value: '0'},
        {text: 'เปิด', value: '1'},
      ],
      filter_bank: '',
      filterOn_bank: [],
      fields_bank: [
        { key: 'bank_name', label: 'ธนาคาร', class: 'text-center text-nowrap' },
        { key: 'account_name', label: 'ชื่อบัญชี', class: 'text-center text-nowrap' },
        { key: 'bank_number', label: 'เลขบัญชี', class: 'text-center' },
        { key: 'start_time_can_not_deposit', label: 'เวลาปิดระบบฝากออโต้', class: 'text-center' },
        { key: 'max_amount_withdraw_auto', label: 'จำนวนเงินถอนออโต้ได้ไม่เกิน (บาท/ครั้ง)', class: 'text-center' },
        { key: 'status', label: 'สถานะ', class: 'text-center' },
        { key: 'status_withdraw', label: 'บัญชีที่ใช้ถอน', class: 'text-center' },
        { key: 'manage', label: 'จัดการข้อมูล', class: 'text-center' },
      ],
      items_bank: [],
      filter: '',
      filterOn: [],
      fields: [
      ],
      items: [],
      t_fetch: 0,
      bank_list: JSON.parse('{"01":"\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e","02":"\u0e01\u0e2a\u0e34\u0e01\u0e23\u0e44\u0e17\u0e22","03":"\u0e01\u0e23\u0e38\u0e07\u0e44\u0e17\u0e22","04":"\u0e17\u0e2b\u0e32\u0e23\u0e44\u0e17\u0e22","05":"\u0e44\u0e17\u0e22\u0e1e\u0e32\u0e13\u0e34\u0e0a\u0e22\u0e4c","06":"\u0e01\u0e23\u0e38\u0e07\u0e28\u0e23\u0e35\u0e2d\u0e22\u0e38\u0e18\u0e22\u0e32","07":"\u0e2d\u0e2d\u0e21\u0e2a\u0e34\u0e19","08":"\u0e18\u0e19\u0e0a\u0e32\u0e15\u0e34","09":"\u0e18.\u0e01.\u0e2a.","1":"\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e","2":"\u0e01\u0e2a\u0e34\u0e01\u0e23\u0e44\u0e17\u0e22","3":"\u0e01\u0e23\u0e38\u0e07\u0e44\u0e17\u0e22","4":"\u0e17\u0e2b\u0e32\u0e23\u0e44\u0e17\u0e22","5":"\u0e44\u0e17\u0e22\u0e1e\u0e32\u0e13\u0e34\u0e0a\u0e22\u0e4c","6":"\u0e01\u0e23\u0e38\u0e07\u0e28\u0e23\u0e35\u0e2d\u0e22\u0e38\u0e18\u0e22\u0e32","7":"\u0e2d\u0e2d\u0e21\u0e2a\u0e34\u0e19","8":"\u0e18\u0e19\u0e0a\u0e32\u0e15\u0e34","9":"\u0e18.\u0e01.\u0e2a."}'),
    }
  },
  mounted() {
    this.totalRows = this.items.length
    // this.fetch()
    this.fetch_bank()
    this.t_fetch = setInterval(() => {
      if (this.currentPage != 1) return;
      this.fetch_bank()
    }, 1000 * 60)
  },
  watch: {
    filter: {
      handler() {
        this.fetch()
        this.totalRows = this.items.length
        this.currentPage = 1
      },
    }
  },
  methods: {
    onFiltered(filteredItems) {
      if (this.filter != '' && this.filter.startsWith('status:')) {
        this.filter = ''
      }
      // this.totalRows = filteredItems.length
      // this.currentPage = 1
    },
    onPageSelect() {
      let start = this.perPage * (this.currentPage - 1)
      this.fetch(start)
    },
    onPageChange(page) {
      let start = this.perPage * (page - 1)
      this.fetch(start)
    },
    load(data) {
      if (data == null || data.data == null) return;
      this.draw = data.draw
      this.items = data.data
      this.totalRows = data.recordsFiltered
      this.recordsTotal = data.recordsTotal
    },
    load_bank(data) {
      this.items_bank = data.result
    },
    fetch(start=0) {
      let url = `bank/bank_list_page?draw=${this.draw}&start=${start}&length=${this.perPage}&search%5Bvalue%5D=${this.filter}&date_start=${this.date_start_report}&date_end=${this.date_end_report}&status=&_=${Date.now()}`;
      this.$http.get(url).then(res => { this.load(res.data) })
    },
    fetch_bank() {
      this.$http.get('bank/bank_list').then(res => { this.load_bank(res.data) })
    },
    loading() {
      this.$swal({
			  text: "กรุณารอสักครู่..",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: '',
        onBeforeOpen: () => {
          this.$swal.showLoading()
        },
      });
    },
    success(text='') {
      this.$swal({
        title: 'แจ้งเตือน',
        text: text,
        icon: 'success',
        confirmButtonText: 'เรียบร้อย',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    warn(text='') {
      this.$swal({
        title: 'แจ้งเตือน',
        text: text,
        icon: 'warning',
        confirmButtonText: 'ตกลง',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    error(text='') {
      this.$swal({
        title: 'แจ้งเตือน',
        text: text,
        icon: 'error',
        confirmButtonText: 'ตกลง',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    toast(icon, title) {
      this.$swal({toast: true, icon: icon, title: title, position: 'top-end', showConfirmButton: false, timer: 2500})
    },
    update_status(status, id) {
      this.loading()
      let data = { status, id }
      this.$http.post('bank/bank_status_update', data).then(res=>{
        this.$swal.close()
        if (res.data.result) {
          this.toast('success', res.data.message)
          this.fetch_bank()
        } else {
          this.toast('error', 'ทำรายการไม่สำเร็จ')
        }
      })
    },
    update_status_withdraw(status_withdraw, id) {
      this.loading()
      let data = { status_withdraw, id }
      this.$http.post('bank/bank_status_withdraw_update', data).then(res=>{
        this.$swal.close()
        if (res.data.result) {
          this.toast('success', res.data.message)
          this.fetch_bank()
        } else {
          this.toast('error', 'ทำรายการไม่สำเร็จ')
        }
      })
    },
    remove(e) {
      let data = {
        id: e.srcElement.attributes['data-id'].value,
        name: e.srcElement.attributes['data-name'].value,
      }
      this.$swal({
        icon: 'warning',
        title: 'แจ้งเตือน',
        text: 'ยืนยันการลบข้อมูล ' + data.name,
        confirmButtonText: 'ตกลง',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary mr-1',
        },
        buttonsStyling: false,
      }).then((res) => {
        if (res.value) {
          this.loading()
          this.$http.post('bank/bank_delete/' + data.id).then((res) => {
            this.$swal.close()
            if (res.data.result) {
              this.success(res.data.message)
              this.fetch_bank()
            } else {
              this.error('ทำรายการไม่สำเร็จ')
            }
          })
        }
      })
    },
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.t_fetch)
    next()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
body.dark-layout.swal2-toast-shown .swal2-container.swal2-top{background-color: #283046}
body.swal2-toast-shown .swal2-container{background-color: transparent}body.swal2-toast-shown .swal2-container.swal2-shown{background-color: transparent}body.swal2-toast-shown .swal2-container.swal2-top{top: 0;right: auto;bottom: auto;left: 50%;-webkit-transform: translateX(-50%);transform: translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top: 0;right: 0;bottom: auto;left: auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top: 0;right: auto;bottom: auto;left: 0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top: 50%;right: auto;bottom: auto;left: 0;-webkit-transform: translateY(-50%);transform: translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top: 50%;right: auto;bottom: auto;left: 50%;-webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top: 50%;right: 0;bottom: auto;left: auto;-webkit-transform: translateY(-50%);transform: translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top: auto;right: auto;bottom: 0;left: 0}body.swal2-toast-shown .swal2-container.swal2-bottom{top: auto;right: auto;bottom: 0;left: 50%;-webkit-transform: translateX(-50%);transform: translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top: auto;right: 0;bottom: 0;left: auto}body.swal2-toast-column .swal2-toast{flex-direction: column;align-items: stretch}body.swal2-toast-column .swal2-toast .swal2-actions{flex: 1;align-self: stretch;height: 2.2em;margin-top: 0.3125em}body.swal2-toast-column .swal2-toast .swal2-loading{justify-content: center}body.swal2-toast-column .swal2-toast .swal2-input{height: 2em;margin: 0.3125em auto;font-size: 1em}body.swal2-toast-column .swal2-toast .swal2-validation-message{font-size: 1em}.swal2-popup.swal2-toast{flex-direction: row;align-items: center;width: auto;padding: 0.625em;box-shadow: 0 0 0.625em #d9d9d9;overflow-y: hidden}.swal2-popup.swal2-toast .swal2-header{flex-direction: row}.swal2-popup.swal2-toast .swal2-title{flex-grow: 1;justify-content: flex-start;margin: 0 0.6em;font-size: 1em}.swal2-popup.swal2-toast .swal2-footer{margin: 0.5em 0 0;padding: 0.5em 0 0;font-size: 0.8em}.swal2-popup.swal2-toast .swal2-close{position: initial;width: 0.8em;height: 0.8em;line-height: 0.8}.swal2-popup.swal2-toast .swal2-content{justify-content: flex-start;font-size: 1em}.swal2-popup.swal2-toast .swal2-icon{width: 2em;min-width: 2em;height: 2em;margin: 0}.swal2-popup.swal2-toast .swal2-icon-text{font-size: 2em;font-weight: 700;line-height: 1em}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width: 2em;height: 2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^="swal2-x-mark-line"]{top: 0.875em;width: 1.375em}.swal2-popup.swal2-toast.swal2-icon.swal2-error[class^="swal2-x-mark-line"][class$="left"]{left: 0.3125em}.swal2-popup.swal2-toast.swal2-icon.swal2-error[class^="swal2-x-mark-line"][class$="right"]{right: 0.3125em}.swal2-popup.swal2-toast .swal2-actions{height: auto;margin: 0 0.3125em}.swal2-popup.swal2-toast .swal2-styled{margin: 0 0.3125em;padding: 0.3125em 0.625em;font-size: 1em}.swal2-popup.swal2-toast .swal2-styled:focus{box-shadow: 0 0 0 0.0625em #fff, 0 0 0 0.125em rgba(50, 100, 150, 0.4)}.swal2-popup.swal2-toast .swal2-success{border-color: #a5dc86}.swal2-popup.swal2-toast .swal2-success [class^="swal2-success-circular-line"]{position: absolute;width: 2em;height: 2.8125em;-webkit-transform: rotate(45deg);transform: rotate(45deg);border-radius: 50%}.swal2-popup.swal2-toast.swal2-success[class^="swal2-success-circular-line"][class$="left"]{top: -0.25em;left: -0.9375em;-webkit-transform: rotate(-45deg);transform: rotate(-45deg);-webkit-transform-origin: 2em 2em;transform-origin: 2em 2em;border-radius: 4em 0 0 4em}.swal2-popup.swal2-toast.swal2-success[class^="swal2-success-circular-line"][class$="right"]{top: -0.25em;left: 0.9375em;-webkit-transform-origin: 0 2em;transform-origin: 0 2em;border-radius: 0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width: 2em;height: 2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top: 0;left: 0.4375em;width: 0.4375em;height: 2.6875em}.swal2-popup.swal2-toast .swal2-success [class^="swal2-success-line"]{height: 0.3125em}.swal2-popup.swal2-toast.swal2-success[class^="swal2-success-line"][class$="tip"]{top: 1.125em;left: 0.1875em;width: 0.75em}.swal2-popup.swal2-toast.swal2-success[class^="swal2-success-line"][class$="long"]{top: 0.9375em;right: 0.1875em;width: 1.375em}.swal2-popup.swal2-toast.swal2-show{-webkit-animation: showSweetToast 0.5s;animation: showSweetToast 0.5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation: hideSweetToast 0.2s forwards;animation: hideSweetToast 0.2s forwards}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-tip{-webkit-animation: animate-toast-success-tip 0.75s;animation: animate-toast-success-tip 0.75s}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-long{-webkit-animation: animate-toast-success-long 0.75s;animation: animate-toast-success-long 0.75s}@-webkit-keyframes showSweetToast{0%{-webkit-transform: translateY(-0.625em) rotateZ(2deg);transform: translateY(-0.625em) rotateZ(2deg);opacity: 0}33%{-webkit-transform: translateY(0) rotateZ(-2deg);transform: translateY(0) rotateZ(-2deg);opacity: 0.5}66%{-webkit-transform: translateY(0.3125em) rotateZ(2deg);transform: translateY(0.3125em) rotateZ(2deg);opacity: 0.7}100%{-webkit-transform: translateY(0) rotateZ(0);transform: translateY(0) rotateZ(0);opacity: 1}}@keyframes showSweetToast{0%{-webkit-transform: translateY(-0.625em) rotateZ(2deg);transform: translateY(-0.625em) rotateZ(2deg);opacity: 0}33%{-webkit-transform: translateY(0) rotateZ(-2deg);transform: translateY(0) rotateZ(-2deg);opacity: 0.5}66%{-webkit-transform: translateY(0.3125em) rotateZ(2deg);transform: translateY(0.3125em) rotateZ(2deg);opacity: 0.7}100%{-webkit-transform: translateY(0) rotateZ(0);transform: translateY(0) rotateZ(0);opacity: 1}}@-webkit-keyframes hideSweetToast{0%{opacity: 1}33%{opacity: 0.5}100%{-webkit-transform: rotateZ(1deg);transform: rotateZ(1deg);opacity: 0}}@keyframes hideSweetToast{0%{opacity: 1}33%{opacity: 0.5}100%{-webkit-transform: rotateZ(1deg);transform: rotateZ(1deg);opacity: 0}}@-webkit-keyframes animate-toast-success-tip{0%{top: 0.5625em;left: 0.0625em;width: 0}54%{top: 0.125em;left: 0.125em;width: 0}70%{top: 0.625em;left: -0.25em;width: 1.625em}84%{top: 1.0625em;left: 0.75em;width: 0.5em}100%{top: 1.125em;left: 0.1875em;width: 0.75em}}@keyframes animate-toast-success-tip{0%{top: 0.5625em;left: 0.0625em;width: 0}54%{top: 0.125em;left: 0.125em;width: 0}70%{top: 0.625em;left: -0.25em;width: 1.625em}84%{top: 1.0625em;left: 0.75em;width: 0.5em}100%{top: 1.125em;left: 0.1875em;width: 0.75em}}@-webkit-keyframes animate-toast-success-long{0%{top: 1.625em;right: 1.375em;width: 0}65%{top: 1.25em;right: 0.9375em;width: 0}84%{top: 0.9375em;right: 0;width: 1.125em}100%{top: 0.9375em;right: 0.1875em;width: 1.375em}}@keyframes animate-toast-success-long{0%{top: 1.625em;right: 1.375em;width: 0}65%{top: 1.25em;right: 0.9375em;width: 0}84%{top: 0.9375em;right: 0;width: 1.125em}100%{top: 0.9375em;right: 0.1875em;width: 1.375em}}
</style>
